// extracted by mini-css-extract-plugin
module.exports = {"bad":"L14_bad__143jg","correct":"L14_correct__2ED-2"};